import { render, staticRenderFns } from "./Pasos.vue?vue&type=template&id=604404cd&scoped=true"
import script from "./Pasos.vue?vue&type=script&lang=js"
export * from "./Pasos.vue?vue&type=script&lang=js"
import style0 from "./Pasos.vue?vue&type=style&index=0&id=604404cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604404cd",
  null
  
)

export default component.exports